export const Props = () => ({
  //----------------------------------------------------------------------------
  //          Применять ли к блоку с описнаием кэпитала адаптивный формат
  //----------------------------------------------------------------------------
  descriptionAdaptive: {
    type: Boolean,
    required: false,
    default: false,
  },
  //----------------------------------------------------------------------------
  //          Показывать ли блок с карточками описания
  //----------------------------------------------------------------------------
  showDescription: {
    type: Boolean,
    required: false,
    default: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});
